import { useNavigate, useParams } from '@exam-management/router';
import { Button, Flex, FormButton, Paper, PaperSection, Text, Alert } from '@shared/components';
import { useDisclosure } from '@shared/hooks';
import { useState } from 'react';

import { AddQBankStructureButton, BasicSettingFormField } from '../../components';
import { QConfigGeneratorCreationFormProvider } from '../../providers';
import { AddQBankToQConfigGeneratorModal } from '../add-qbank-to-qconfig-generator-modal';
import { QBankStructureSettingSectionGroup } from '../qbank-structure-setting-section-group';

export default function QConfigGeneratorCreation() {
  const { courseId } = useParams('/exam-courses/:courseId/qconfig-generators/create');
  const navigate = useNavigate();

  const [isAddQBankToQConfigGeneratorModalOpen, addQBankToQConfigGeneratorModalHandlers] =
    useDisclosure(false);
  const { open, close } = addQBankToQConfigGeneratorModalHandlers;
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  return (
    <QConfigGeneratorCreationFormProvider setErrorMessage={setErrorMessage}>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(6),
          p: theme.spacing(6),
        })}
      >
        {errorMessage ? <Alert severity='error'>{errorMessage}</Alert> : null}
        <Paper sx={{ p: (theme) => theme.spacing(6) }}>
          <BasicSettingFormField />
        </Paper>
        <PaperSection
          title={
            <Flex sx={{ justifyContent: 'space-between', width: '100%' }}>
              <Text variant='h3'>Question Bank</Text>
              <AddQBankStructureButton onClick={open} />
            </Flex>
          }
        >
          <QBankStructureSettingSectionGroup openAddQBankToQConfigGeneratorModal={open} />
        </PaperSection>
        <Flex sx={{ justifyContent: 'flex-end', gap: (theme) => theme.spacing(3) }}>
          <Button
            variant='outlined'
            color='secondary'
            size='large'
            onClick={() =>
              navigate(`/exam-courses/:courseId/qconfig-generators`, {
                params: { courseId },
              })
            }
          >
            Cancel
          </Button>
          <FormButton size='large' label='Generate QConfig' />
        </Flex>
      </Flex>
      {isAddQBankToQConfigGeneratorModalOpen ? (
        <AddQBankToQConfigGeneratorModal
          open={isAddQBankToQConfigGeneratorModalOpen}
          onClose={close}
        />
      ) : null}
    </QConfigGeneratorCreationFormProvider>
  );
}
